import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { type APIConfig } from "../../types/api";
import { type PayloadActionForAPI } from "../../types/app";
import { type Organization } from "../../types/organization";

export type OrganizationSliceState = {
   list?: Organization[];
   selectedOrganizationId?: Organization["id"];
};

const initialState: OrganizationSliceState = {};

export const organizationsSlice = createSlice({
   name: "organizations",
   initialState,
   reducers: {
      getAllOrganizations: (_, __: PayloadActionForAPI<APIConfig["getAllOrganizations"], {}, true>) => {},
      getOrganizationById: (
         _,
         __: PayloadActionForAPI<
            APIConfig["getOrganizationById"],
            {
               id: Organization["id"];
            }
         >,
      ) => {},
      setOrganizations: (state, action: PayloadAction<OrganizationSliceState["list"]>) => {
         state.list = action.payload;
      },
      createOrganization: (_, __: PayloadActionForAPI<APIConfig["createOrganization"]>) => {},
      editOrganization: (
         _,
         __: PayloadActionForAPI<
            APIConfig["editOrganization"],
            {
               id: Organization["id"];
            }
         >,
      ) => {},
      updateOrganization: (
         state,
         action: PayloadAction<
            NonNullable<OrganizationSliceState["list"]> | NonNullable<OrganizationSliceState["list"]>[number]
         >,
      ) => {
         const newItems = Array.isArray(action.payload) ? action.payload : [action.payload];

         if (!state.list) state.list = [];

         for (let index = 0; index < newItems.length; index++) {
            const newItem = newItems[index];
            const stateListIndex = state.list.findIndex((item) => item.id === newItem.id);

            if (stateListIndex !== -1)
               state.list[stateListIndex] = {
                  ...state.list[stateListIndex],
                  ...newItem,
               };
            else state.list.push(newItem);
         }
      },
      removeOrganization: (state, action: PayloadAction<NonNullable<OrganizationSliceState["list"]>[number]["id"]>) => {
         state.list = state.list?.filter((item) => item.id !== action.payload);
      },

      setSelectedOrganizationId: (
         state,
         action: PayloadAction<{
            organizationId: Organization["id"];
            isChange?: boolean;
         }>,
      ) => {
         state.selectedOrganizationId = action.payload.organizationId;
      },
   },
});
